import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row items-center" }
const _hoisted_2 = { class: "pt-2 text-start" }
const _hoisted_3 = { class: "text-gray-text" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", { class: "text-white uppercase mb-3" }, "Token Details", -1)
const _hoisted_6 = { class: "bg-black-sidebar w-full md:w-96 lg:w-100 mb-5" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-yellow-bar p-3 text-left" }, "Token"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-yellow-bar p-3 text-left" }, "Current Balance")
  ])
], -1)
const _hoisted_8 = { class: "p-3 text-white text-md" }
const _hoisted_9 = { class: "font-semibold" }
const _hoisted_10 = { class: "text-gray-text text-sm" }
const _hoisted_11 = { class: "p-3 text-white text-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, "Username: " + _toDisplayString(_ctx.username), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("table", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayTokens, (token, index) => {
            return (_openBlock(), _createElementBlock("tr", { key: index }, [
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(token.names[0]?token.names[0]:token.tokenId), 1),
                _createElementVNode("span", _hoisted_10, _toDisplayString(token.title?token.title:token.description), 1)
              ]),
              _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.Helper.toCurrencyFormat(token.amount, 0)), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}